import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Include Helper File with needed methods
import {
	getDataReportOxygen as getDataReportOxygenApi,
	getDataReportTemperature as getDataReportTemperatureApi,
	getDataReportSaturation as getDataReportSaturationApi,
	getDataReportSalinity as getDataReportSalinityApi,
	getDataReportTurbidity as getDataReportTurbidityApi,
	getDataReportChlorophyll as getDataReportChlorophyllApi,
	getDataReportAll as getDataReportAllApi,
	getInformationRegisterSMAList as getInformationRegisterSMAListApi,
	addInformationRegisterSMA as addInformationRegisterSMAApi,
	getMeasurementsList as getMeasurementsListApi,
	getMeasurementsQuery as getMeasurementsQueryApi,
	getIncidentsQuery as getIncidentsQueryApi,
	getMeasurementsDetailQuery as getMeasurementsDetailQueryApi,
} from '../../helpers/data_providers/backend_helper';

// Oxygen Data Thunk
export const getDataReportOxygen = createAsyncThunk(
	'dataProviders/getDataReportOxygen',
	async params => {
		try {
			const response = await getDataReportOxygenApi(params);
			return response['data'];
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Temperature Data Thunk
export const getDataReportTemperature = createAsyncThunk(
	'dataProviders/getDataReportTemperature',
	async params => {
		try {
			const response = await getDataReportTemperatureApi(params);
			return response['data'];
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Saturation Data Thunk
export const getDataReportSaturation = createAsyncThunk(
	'dataProviders/getDataReportSaturation',
	async params => {
		try {
			const response = await getDataReportSaturationApi(params);
			return response['data'];
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Salinity Data Thunk
export const getDataReportSalinity = createAsyncThunk(
	'dataProviders/getDataReportSalinity',
	async params => {
		try {
			const response = await getDataReportSalinityApi(params);
			return response['data'];
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Turbidity Data Thunk
export const getDataReportTurbidity = createAsyncThunk(
	'dataProviders/getDataReportTurbidity',
	async params => {
		try {
			const response = await getDataReportTurbidityApi(params);
			return response['data'];
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Chlorophyll Data Thunk
export const getDataReportChlorophyll = createAsyncThunk(
	'dataProviders/getDataReportChlorophyll',
	async params => {
		try {
			const response = await getDataReportChlorophyllApi(params);
			return response['data'];
		} catch (error) {
			throw new Error(error);
		}
	}
);

// All Data Thunk
export const getDataReportAll = createAsyncThunk(
	'dataProviders/getDataReportAll',
	async params => {
		try {
			const response = await getDataReportAllApi(params);
			return response['data'];
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Get medition list thunk
export const getMeasurementList = createAsyncThunk(
	'dataProviders/getMeasurementList',
	async params => {
		try {
			const response = await getMeasurementsListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getMeasurementQuery = createAsyncThunk(
	'dataProviders/getMeasurementQuery',
	async params => {
		try {
			const response = await getMeasurementsQueryApi(params);
			return response?.data;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getIncidentsQuery = createAsyncThunk(
	'dataProviders/getIncidentsQuery',
	async params => {
		try {
			const response = await getIncidentsQueryApi(params);
			return response?.data;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getMeasurementDetailQuery = createAsyncThunk(
	'dataProviders/getMeasurementDetailQuery',
	async params => {
		try {
			const response = await getMeasurementsDetailQueryApi(params);
			return response?.data;
		} catch (error) {
			throw new Error(error);
		}
	}
);

// Get catastro list thunk
export const getInformationRegisterSMAList = createAsyncThunk(
	'dataProviders/getInformationRegisterSMAList',
	async params => {
		try {
			const response = await getInformationRegisterSMAListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addInformationRegisterSMA = createAsyncThunk(
	'dataProviders/addInformationRegisterSMA',
	async params => {
		try {
			const response = await addInformationRegisterSMAApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);
